<template>

  <v-select :label="$t('device.hub_name')"
            v-model="selected"
            multiple
            dense
            item-text="name"
            item-value="_id"
            :items="sortedInstallations"
            @input="select()">
    <template v-slot:selection="{ item, index }">
      <div v-if="selected.length === 1">
        {{ item.name }}
      </div>
      <span v-else-if="index === 1" class="grey--text text-caption">
        ({{ selected.length }})
      </span>
    </template>
  </v-select>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "InstallationFilter",
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    ...mapGetters(["getAllInstallations"]),
    sortedInstallations() {
      return this.getAllInstallations.sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    select: async function () {
      this.$emit("input", this.selected)
      await this.$nextTick();
    }
  }
}
</script>

<style scoped>

</style>